import {
  FeatureFlagsProvider,
  initTracking,
  trackEvent,
} from "@justhome/common";
import { PropsWithChildren } from "react";

initTracking();

const trackExperimentViewed = (experimentKey: string, variationId: number) => {
  trackEvent(experimentKey, { variationId });
};

const GrowthbookProvider = ({ children }: PropsWithChildren) => (
  <FeatureFlagsProvider
    url={window.location.href}
    onExperimentViewed={trackExperimentViewed}
  >
    {children}
  </FeatureFlagsProvider>
);

export default GrowthbookProvider;
